import { useMount } from 'react-use';

import { EmergencyNotificationConfiguration } from '@dreryk/egabinet-emergency-notification-frontend-api';
import { PractitionerView } from '@dreryk/egabinet-personnel-frontend-api';

import { useInteractiveTableContext } from '@dreryk/react-components';

import { isEmpty } from '~libs.typescript';

import { EmergencyNotificationInAppConfigurationResponseTeamPractitionerValue } from '../EmergencyNotificationInAppConfigurationResponseTeamPractitionersField.types';

type EmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTableSynchronizationProps = {
   readonly emergencyNotificationConfiguration: EmergencyNotificationConfiguration;
   readonly practitioners: PractitionerView[];
};

export const EmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTableSynchronization = (
   props: EmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTableSynchronizationProps
): null => {
   const {
      addRow,
      getValues,
   } = useInteractiveTableContext<EmergencyNotificationInAppConfigurationResponseTeamPractitionerValue>();

   useMount(() => {
      if (isEmpty(getValues())) {
         const defaultValue = props.emergencyNotificationConfiguration.inAppConfiguration.responseTeamPractitionerIds.reduce(
            (result, practitionerId) => {
               const foundPractitioner = props.practitioners.find(
                  (practitioner) => practitioner.id === practitionerId.asNumber()
               );
               if (foundPractitioner) {
                  result.push({
                     practitioner: foundPractitioner,
                  });
               }
               return result;
            },
            [] as EmergencyNotificationInAppConfigurationResponseTeamPractitionerValue[]
         );
         addRow(defaultValue, 'append');
      }
   });

   return null;
};
